import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3 3.25A1.75 1.75 0 0 0 1.25 5v13.818c0 .944.67 1.932 1.75 1.932h18c1.08 0 1.75-.988 1.75-1.932V5A1.75 1.75 0 0 0 21 3.25zm18.25 3.286V5a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v1.536l8.691 4.346a1.25 1.25 0 0 0 1.118 0zM2.75 8.213v10.605c0 .157.054.279.115.351.06.07.11.08.135.08h18c.024 0 .075-.01.135-.08a.55.55 0 0 0 .115-.351V8.213l-8.02 4.01a2.75 2.75 0 0 1-2.46 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }